
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sources/webhook",
      function () {
        return require("private-next-pages/events/sources/webhook.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sources/webhook"])
      });
    }
  